import { getPartnerCreateLabel, PARTNER_SERVICE_CONFIG } from './partnerServices';

export const ENTITY_TYPES = PARTNER_SERVICE_CONFIG.map((c) => c.key);

export interface DocumentReviewStep {
  id: string;
  tabIndex: number;
  label: string;
  subtitle: string;
  color: string;
}

export const DOCUMENT_REVIEW_STEPS: DocumentReviewStep[] = [
  {
    id: 'partner_review',
    tabIndex: 0,
    label: 'Partner Review',
    subtitle: 'Verify uploaded documents and approve onboarding',
    color: '#ea580c',
  },
  {
    id: 'groups',
    tabIndex: 1,
    label: 'Document Groups',
    subtitle: 'Configure groups and document types partners must upload',
    color: '#2563eb',
  },
];

export function entityLabel(entityType: string): string {
  if (!entityType) return '—';
  if (entityType === 'partner') return 'All partners';
  if (entityType === 'vendor') return 'Vendor';
  return getPartnerCreateLabel(entityType)
    || entityType.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
}

export function isLockedPartnerProfileDocument(doc: { code?: string; isSystem?: boolean }) {
  return doc.isSystem === true || doc.code === 'profile_photo';
}

export function isLockedPartnerProfileGroup(group: { code?: string; isSystem?: boolean; entityType?: string }) {
  return group.isSystem === true || group.code === 'partner_profile' || group.entityType === 'partner';
}

/** Instructional notes and helper copy — darker than default text.secondary for readability. */
export const DOCUMENT_REVIEW_NOTE_SX = {
  color: 'text.primary',
  opacity: 0.9,
  lineHeight: 1.55,
  fontWeight: 500,
} as const;

export const DOCUMENT_REVIEW_ALERT_SX = {
  borderRadius: 2,
  '& .MuiAlert-message': {
    color: 'text.primary',
    fontWeight: 500,
    lineHeight: 1.55,
  },
} as const;

export const DOCUMENT_FORM_HELPER_SX = {
  '& .MuiFormHelperText-root:not(.Mui-error)': {
    color: 'text.primary',
    opacity: 0.85,
    fontWeight: 500,
  },
} as const;

